import { BALANCE } from '../config/balance';

export interface Particle {
  active: boolean;
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  maxLife: number;
  size: number;
  color: string;
  /** ring=true：扩散圆环（爆炸冲击波），size 随时间增长。 */
  ring: boolean;
}

export function createParticle(): Particle {
  return {
    active: false,
    x: 0,
    y: 0,
    vx: 0,
    vy: 0,
    life: 0,
    maxLife: 1,
    size: 1,
    color: '#191919',
    ring: false,
  };
}

export function updateParticle(p: Particle, dt: number): void {
  p.life -= dt;
  if (p.ring) {
    p.size += BALANCE.juice.ringExpandSpeed * dt;
    return;
  }
  p.x += p.vx * dt;
  p.y += p.vy * dt;
  const d = Math.exp(-BALANCE.juice.particleDamp * dt);
  p.vx *= d;
  p.vy *= d;
}

/** 剩余寿命比例，渲染算 alpha。 */
export function particleAlpha(p: Particle): number {
  return Math.max(0, p.life / p.maxLife);
}
